import type { DocumentExportConfig } from '../types/documentExport'

export const pdfExportService = {
  async download(config: DocumentExportConfig): Promise<void> {
    const { renderDocumentPdf } = await import('../utils/pdf/renderDocumentPdf')
    const bytes = await renderDocumentPdf(config)
    const blob = new Blob([bytes as BlobPart], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = config.filename.endsWith('.pdf') ? config.filename : `${config.filename}.pdf`
    anchor.click()
    URL.revokeObjectURL(url)
  },
}
